import { motion } from "framer-motion";
import { useT } from "@/lib/LanguageContext";

export default function HowIHelp() {
  const { t } = useT();
  const h = t.help;

  return (
    <section
      id="ayuda"
      data-testid="how-i-help-section"
      className="relative py-24 md:py-36 bg-[#F7F3F7]"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-6 md:gap-10 mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-7">
            <p className="text-[11px] uppercase tracking-[0.24em] text-[#6B4E6F] mb-6">
              {h.eyebrow}
            </p>
            <h2
              data-testid="how-i-help-headline"
              className="font-serif font-light text-[clamp(2.2rem,5vw,4.5rem)] leading-[0.95] tracking-tight"
            >
              {h.headline.l1}
              <br />
              {h.headline.l2}
              <br />
              <span className="italic">{h.headline.l3}</span>
            </h2>
          </div>
          <div className="col-span-12 md:col-span-4 md:col-start-9 self-end">
            <p className="text-lg leading-relaxed text-[#6B4E6F]">{h.lead}</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#4B2F4F]/10">
          {h.steps.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.55, delay: i * 0.1 }}
              data-testid={`help-step-${i}`}
              className="relative bg-[#F7F3F7] p-10 md:p-12 min-h-[300px] flex flex-col"
            >
              <p className="font-serif text-6xl md:text-7xl text-[#E0B25B] leading-none">
                {s.n}
              </p>
              <div className="my-7 w-12 h-px bg-[#4B2F4F]/20" />
              <h3 className="font-serif text-2xl md:text-3xl leading-tight tracking-tight">
                {s.title}
              </h3>
              <p className="mt-4 text-base leading-relaxed text-[#6B4E6F]">
                {s.text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
